import RequestManager from "./RequestManager";
import Utils from "../utils/utils";

const getUiPermissionsForDomain = async (domainId) => {
    const urlParams = Utils.getUrlParams({});

    const response = await RequestManager.get({
        url: `/permission/domain/v1/${domainId}${urlParams}`
    });
    return response;
};

const Permission = {
    getUiPermissionsForDomain
};

export default Permission;